import { initReactI18next } from 'react-i18next';
import { de, en, it } from '@guryou/translations';
import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';

i18n
  .use(detector)
  .use(initReactI18next)
  .init({
    lng: process.env.REACT_APP_LANGUAGE,
    resources: { de, en, it },
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
